import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import useStore from 'services/store';
import api from 'services/api';

export const Header = () => {
  const navigate = useNavigate();
  const {user, setUser } = useStore();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    setUser(null)
    api.setToken("")
    localStorage.removeItem("token")
    setShowDropdown(false);
    navigate('/login');
  };

  return (
    <header className="bg-white shadow-sm fixed top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to={user? "/home" : "/"} className="flex items-center space-x-2">
            <span className="font-bold text-xl text-black font-sans">RigidAthlete</span>
          </Link>

          <nav className="flex items-center space-x-4">
            {user ? (
              <>
                <div className="hidden md:flex items-center space-x-4">
                  <Link
                    to="/home"
                    className="text-black hover:text-gray-700 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Home
                  </Link>
                  <Link
                    to="/meal-dashboard"
                    className="text-black hover:text-gray-700 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Meal Dashboard
                  </Link>
                  <Link
                    to="/exercise-dashboard"
                    className="text-black hover:text-gray-700 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Exercise Dashboard
                  </Link>
                  <Link
                    to="/progress-dashboard"
                    className="text-black hover:text-gray-700 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Progress Dashboard
                  </Link>
                </div>
                
                <div className="relative">
                  <button
                    onClick={() => setShowDropdown(!showDropdown)}
                    className="flex items-center space-x-2 text-black hover:text-gray-700"
                  >
                    <FaUserCircle className="h-8 w-8" />
                  </button>
                  {showDropdown && (
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10">
                      <div className="md:hidden">
                        <Link
                          to="/home"
                          className="block px-4 py-2 text-sm text-black hover:bg-gray-100"
                          onClick={() => setShowDropdown(false)}
                        >
                          Home
                        </Link>
                        <Link
                          to="/meal-dashboard"
                          className="block px-4 py-2 text-sm text-black hover:bg-gray-100"
                          onClick={() => setShowDropdown(false)}
                        >
                          Meal Dashboard
                        </Link>
                        <Link
                          to="/exercise-dashboard"
                          className="block px-4 py-2 text-sm text-black hover:bg-gray-100"
                          onClick={() => setShowDropdown(false)}
                        >
                          Exercise Dashboard
                        </Link>
                        <Link
                          to="/progress-dashboard"
                          className="block px-4 py-2 text-sm text-black hover:bg-gray-100"
                          onClick={() => setShowDropdown(false)}
                        >
                          Progress Dashboard
                        </Link>
                      </div>
                      <Link
                        to="/profile"
                        className="block px-4 py-2 text-sm text-black hover:bg-gray-100"
                        onClick={() => setShowDropdown(false)}
                      >
                        Profile
                      </Link>
                      <button
                        onClick={handleLogout}
                        className="block w-full text-left px-4 py-2 text-sm text-black hover:bg-gray-100"
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-black hover:text-gray-700 px-3 py-2 rounded-md text-sm font-medium"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="bg-black text-white hover:bg-gray-900 px-4 py-2 rounded-md text-sm font-medium"
                >
                  Sign Up
                </Link>
              </>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};
